export default __webpack_public_path__ + "static/media/twitter.975eaac3.svg";